import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import {
  AttendanceCredentialsPayload,
  AttendanceResponse,
  MarkAttendanceResponse,
  TodayAttendanceFilters,
  TodayAttendanceResponse,
  UpdateAttendancePayload,
  VerifyAttendanceResponse,
} from '../models/attendance';

@Injectable({
  providedIn: 'root',
})
export class AttendanceService {
  private readonly apiUrl =
    'https://apirba.msiddiquesteel.com/api/attendance';

  constructor(
    private readonly http: HttpClient
  ) { }


  // Verify Attendance PIN and determine next action
  verifyAttendance(
    payload: AttendanceCredentialsPayload
  ): Observable<VerifyAttendanceResponse> {

    return this.http.post<VerifyAttendanceResponse>(
      `${this.apiUrl}/verify`,
      payload
    );
  }

  // Check-In Employee or Intern
  checkIn(
    payload: AttendanceCredentialsPayload
  ): Observable<MarkAttendanceResponse> {

    return this.http.post<MarkAttendanceResponse>(
      `${this.apiUrl}/check-in`,
      payload
    );

  }

  // Check-Out Employee or Intern
  checkOut(
    payload: AttendanceCredentialsPayload
  ): Observable<MarkAttendanceResponse> {

    return this.http.post<MarkAttendanceResponse>(
      `${this.apiUrl}/check-out`,
      payload
    );

  }

  // Get today's attendance records
  getTodayAttendance(
    filters: TodayAttendanceFilters = {}
  ): Observable<TodayAttendanceResponse> {
    let params = new HttpParams();

    if (filters.employeeType) {
      params = params.set(
        'employeeType',
        filters.employeeType
      );
    }

    if (filters.attendanceStatus) {
      params = params.set(
        'attendanceStatus',
        filters.attendanceStatus
      );
    }

    if (filters.attendanceState) {
      params = params.set(
        'attendanceState',
        filters.attendanceState
      );
    }

    if (filters.search?.trim()) {
      params = params.set(
        'search',
        filters.search.trim()
      );
    }

    return this.http.get<TodayAttendanceResponse>(
      `${this.apiUrl}/today`,
      {
        params,
      }
    );
  }

  // Get single attendance record by ID
  getAttendanceById(
    attendanceId: string
  ): Observable<AttendanceResponse> {
    return this.http.get<AttendanceResponse>(
      `${this.apiUrl}/${attendanceId}`
    );
  }

  // Update attendance manually by Admin
  updateAttendance(
    attendanceId: string,
    payload: UpdateAttendancePayload
  ): Observable<AttendanceResponse> {
    return this.http.patch<AttendanceResponse>(
      `${this.apiUrl}/${attendanceId}`,
      payload
    );
  }
}